<script>
import RichTextEditor from 'dashboard/components/widgets/RichTextEditor/RichTextEditor.vue';
import ResizableTextArea from 'shared/components/ResizableTextArea.vue';

export default {
  components: {
    RichTextEditor,
    ResizableTextArea,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    richtext: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      greetingsMessage: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.greetingsMessage = newValue;
    },
  },
  methods: {
    handleInput() {
      this.$emit('input', this.greetingsMessage);
    },
    onBlur() {
      this.$emit('blur');
    },
  },
};
</script>

<template>
  <section class="w-3/4">
    <label v-if="label" class="mb-2">
      {{ label }}
    </label>
    <div
      v-if="richtext"
      class="px-4 py-0 mx-0 mt-0 mb-4 bg-surface border border-solid rounded-md border-line"
    >
      <!-- Campo de formulario, e nao caixa de resposta: ver o comentario em
           `settings/inbox/Settings.vue`. -->
      <RichTextEditor
        v-model="greetingsMessage"
        enable-variables
        :focus-on-mount="false"
        class="bg-surface input"
        :placeholder="placeholder"
        :min-height="4"
        @input="handleInput"
        @blur="onBlur"
      />
    </div>
    <ResizableTextArea
      v-else
      v-model="greetingsMessage"
      :rows="4"
      type="text"
      class="greetings--textarea"
      :placeholder="placeholder"
      @input="handleInput"
      @blur="onBlur"
    />
  </section>
</template>
